import React, { useState, useEffect } from 'react';

import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Grid, List, ListItem, ListItemText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function MakePayment({ Payflow }) {
  const [ActiveArray, setArray1] = useState({});

  const [Details, setDetails] = useState([]);

  useEffect(() => {
    setDetails(Payflow?.courseEmployees?.organizaionDetails)
    setArray1(Payflow)

  }, [Payflow]);

  // Grouping by clientName
  const clientsGrouped = {};
  Details.forEach((detail) => {
    const { clientName, feecap, trainings } = detail;
    if (!clientsGrouped[clientName]) {
      clientsGrouped[clientName] = { feecap, courses: [] };
    }
    // Grouping by courseName
    trainings.forEach((training) => {
      const { courseName, courseFee, employees } = training;
      const existingCourse = clientsGrouped[clientName]?.courses?.find((course) => course?.courseName === courseName);
      if (existingCourse) {
        existingCourse?.employees?.push(...employees);
      } else {
        clientsGrouped[clientName]?.courses?.push({
          courseName,
          courseFee,
          employees,
        });
      }
    });
  });
  const [isLoading, setIsLoading] = useState(true);

  setTimeout(() => {
    setIsLoading(false)
  }, "5000");



  const totalFeecap = Payflow?.courseEmployees?.organizaionDetails?.reduce((acc, client) => acc + client?.feecap, 0);
  // const actual = (Payflow.courseEmployees?.organizaionDetails?.map((client) => client.trainings.map((training) => (
  //   training?.employees?.reduce((total, employee) => total + employee.amount, 0)
  // ))));


  // var total = actual[0]?.reduce(function (acc, currentValue) {
  //   return acc + currentValue;
  // }, 0);
  const actual = Payflow?.courseEmployees?.organizaionDetails?.map((client) =>
    client?.trainings?.map((training) => (
      training?.employees?.reduce((total, employee) => total + employee?.amount, 0)
    ))
  );


  const totals = actual?.map((item) => (
    item?.reduce((acc, currentValue) => acc + currentValue, 0)
  ));


  const grandTotal = totals?.reduce((acc, currentValue) => acc + currentValue, 0);

  // useEffect(() => {
  //   const successData = { status: "success" };
  //   debugger;
  //   window.parent.postMessage(successData, "*");

  // }, []);

  // const handleSuccessfulPayment = () => {

  //   setTimeout(() => {
  //     handlePaymentSuccess();
  //   }, 2000); 
  // };
  return (
    <Box>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} sx={{ height: "100%" }}>
          <Grid item xs={12} sm={8} md={8}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "10px", backgroundColor: "#DEEDF7", height: "100%" }}>
              <span className='mx-3' style={{color:"red"}}>Please do not refresh or click back button</span>
              <iframe src={Payflow?.url + "&SECURETOKEN=" + Payflow?.token + "&SECURETOKENID=" + Payflow?.tokenId} style={{ height: "80vh", overflowY: "hidden", width: "100%" }} />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>

            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "10px", backgroundColor: "#fff", height: "100%" }}>
              <p style={{ color: "#101828", fontSize: "20px", marginBottom: "20px", fontWeight: "600" }}>Order Summary</p>

              {Object.keys(clientsGrouped)?.map((clientName) => (
                <React.Fragment key={clientName}>
                  <Accordion  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: "#2A93DB" }} />} sx={{ backgroundColor: "#DEEDF7", color: "#2A93DB" }}>
                      <Typography >{clientName}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <List>
                        {clientsGrouped[clientName]?.courses?.map((course) => (
                          <div key={course?.courseName} >
                            <div style={{ backgroundColor: "#F2F4F7", padding: "10px" }}>
                              <span style={{ fontWeight: "bold" }}>{course?.courseName}</span>
                              <span style={{ float: "right", fontWeight: "bold" }}>$ {course?.courseFee}</span></div>
                            <List>
                              {course?.employees?.map((employee) => (
                                <div key={employee?.employeeId} style={{ padding: "10px" }}>
                                  <span className='mx-2' style={{ fontSize: "15px" }}>{employee?.employeeName}</span>
                                  <span style={{ float: "right", fontSize: "15px" }}>$ {course?.courseFee}</span>
                                </div>
                              ))}
                            </List>
                          </div>
                        ))}
                      </List>
                    </AccordionDetails>
                  </Accordion>
                  <Box sx={{ padding: "10px", backgroundColor: "#fff" }}>


                  </Box>
                </React.Fragment>
              ))}
              <Box  sx={{ fontSize: "14px", padding: "6px" }}>
                <div>
                  <span >Actual Amount:</span>
                  <span style={{ float: "right", marginBottom: "2px" }}>
                    ${grandTotal}
                  </span>
                </div>
                <hr />
                <div>
                  <span >Fee Cap Applicable:</span>
                  <span style={{ float: "right", marginBottom: "2px" }}>
                    ${totalFeecap}
                  </span>
                </div>
           <br />
                <div style={{ backgroundColor: "#F2F4F7", padding: "10px" }}>


                  TOTAL AMOUNT:    <span style={{ float: "right", marginBottom: "2px" }}>${grandTotal - totalFeecap}</span>
                </div>
              </Box>
            </Box>

          </Grid>

        </Grid>
      </Box>
    </Box>
  )
}
